import React from 'react';
import Button from '../button/Button';
import { Row, Table } from 'reactstrap';
import { useAppSelector } from '../../reduxToolkit/hooks';
import DeleteIcon from '../svg/DeleteIcon';
import EditIcon from '../svg/EditIcon';
import DetailsIcon from '../svg/Details';
import AddIcon from '../svg/AddIcon';

function Tables({ data, columns, buttons, isAction = true }: any) {
  const role = useAppSelector((state: any) => state.role.role);
  const totalColumns = role === "Administrator" ? columns.length + 1 : columns.length;
  const columnWidth = `${100 / totalColumns}%`;

  return (
        <>
        <div style={{ width:'100%',  overflowY: 'hidden' }}>
       <Table
         className="text-center "
         size="sm"
         hover

         style={{ fontSize: '0.95rem', fontFamily: 'Segoe UI, Roboto, sans-serif' 
      }}
    >
      <thead className="bg-light-primary">
        <tr>
          {columns.map((col: any, index: any) => (
              
            <th
             

              style={{ 
                fontWeight: 600,
                color: '#333',
                padding: '6px',
                fontSize: '1rem',
                width: columnWidth,
                height: '50px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              key={index}
            >
              {col.header}
            </th>
          ))}
          {role === "Administrator" && isAction && (
            <th
              className="table-header"
              style={{
                fontWeight: 600,
                color: '#333',   
                padding: '5px',
                fontSize: '1rem',
                width: columnWidth,
                maxWidth: '80px',
                height: '50px',
              }}
            >
              Action
            </th>
          )}
        </tr>
      </thead>

      <tbody className="table-body w-100">
        {data.map((row: any, rowIndex: number) => (
          <tr key={row.id} >
            {columns.map((col: any, colIndex: any) => (
                    
              <td
                key = {colIndex}
                style={{
                    padding: '5px',
                    /*whiteSpace: (col.accessor === 'farmerName' || col.accessor === 'nameOfBeneficiary')
                    ? 'normal'
                    : 'nowrap',
                  textOverflow: (col.accessor === 'farmerName' || col.accessor === 'nameOfBeneficiary')
                    ? 'unset'
                    : 'ellipsis',
                  maxWidth: (col.accessor === 'farmerName' || col.accessor === 'nameOfBeneficiary')
                    ? '400px'
                    : 'auto',*/
                }}
              >
                {String(row[col.accessor])}
              </td>
))}

            {role === "Administrator" && isAction && (
              <td>
                <div className="d-flex justify-content-center p-0">
                  {buttons.map((button: any, index: any) => (
                    <Button
                       key={index}
                       color={button.color}
                       onClick={() => button.onClick(row.id)}
                       className={`${button.className} main-button d-flex justify-content-center`}
                    >
                      <div style={{ width: '20px', height: '20px' }}>
                         {button.label === 'Delete' && <DeleteIcon />}
                         {button.label === 'Edit' && <EditIcon />}
                         {button.label === 'Details' && <DetailsIcon />}
                         {button.label === 'Add' && <AddIcon/>}
                      </div>
                    </Button>
                  ))}
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
 </div>
 </>
  );
}

export default Tables;
